const apiURI = process.env.REACT_APP_API_TEST;

export default apiURI;